<template>
  <div class="personal-info-container">
    <v-card height="64px" width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position:fixed; z-index:200; top:0; width: 98%; padding-top: 16px;">
      <v-card-title class="ml-0 pl-0">
        <p @click="$router.push('/users')" class="breadcrumb-text cursor">Users</p><v-icon
          class="breadcrumb-arrow">mdi-chevron-right</v-icon>
        <p class="breadcrumb-text">Edit Preferences</p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <UserNavMenu/>
    </v-card>
    <div fluid class="pad pb-8 px-8">
      <strong class="ml-4">Edit Preferences</strong>
      <div class="cdz">
        <v-card class="background elevation-0">
          <v-card-text>
            <div class="d-flex justify-center flex-column align-center">
                                    <v-card class="w-100 mt-4 pt-4">
                                        
                                        <v-container fluid class="py-0 webapp-registration-container">
                                            <v-autocomplete 
                                                v-model="userIntrestData.jobType" 
                                                clearable
                                                deletable-chips
                                                outlined 
                                                class="rounded-xl text-input-field school-text-field"
                                                :items="jobTypes" 
                                                :rules="[(v) => !!v || 'Job Type is required']"
                                                required 
                                                @change="jobTypeChange()"
                                                item-text="name"
                                                item-value="name"
                                                :disabled="(campaignStatus && campaignStatus.length > 1)"
                                              >
                                                <template #label>
                                                  <span>
                                                  Job Type <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                        
                                            <v-autocomplete v-model="userIntrestData.department"
                                                clearable 
                                                deletable-chips
                                                outlined 
                                                class="rounded-xl text-input-field school-text-field"
                                                :items="departments"
                                                required
                                                @change="departmentChange()"
                                                :disabled="(campaignStatus && campaignStatus.length > 1)"
                                                >
                                                <template #label>
                                                  <span>
                                                    Department <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                        
                                        
                                            <v-autocomplete v-model="userIntrestData.jobRole" clearable deletable-chips
                                                outlined class="rounded-xl text-input-field school-text-field"
                                                :items="jobRoles" item-text="HRIS_unique_role" 
                                                required
                
                                                id="jobRole" 
                                                return-object
                                                @change="jobroleChange($event)"
                                                label="Preferred Job Role"
                                                :disabled="(campaignStatus && campaignStatus.length > 1)"
                                                >
                                                <template #label>
                                                  <span>
                                                    Preferred Job Role <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete multiple v-model="userIntrestData.otherJob" clearable
                                                deletable-chips outlined
                
                                                class="rounded-xl text-input-field school-text-field jobseeker-interest-chip"
                                                small-chips 
                                                :items="otherJobRoles"
                                                item-text="HRIS_unique_role"
                                                id="jobRole"
                                                label="Other Job Role"
                                                :disabled="(campaignStatus && campaignStatus.length > 1)"
                                                >
                                                <template v-slot:item="{ item, attrs, on }">
                                                    <v-list-item v-bind="attrs" v-on="on"
                                                        :disabled="userIntrestData.jobRole && item.HRIS_unique_role === userIntrestData.jobRole.HRIS_unique_role">
                                                        <template v-slot:default="{ active }">
                                                            <v-list-item-action>
                                                                <v-checkbox :input-value="active" color="primary"
                                                                    :disabled="userIntrestData.jobRole && item.HRIS_unique_role === userIntrestData.jobRole.HRIS_unique_role"></v-checkbox>
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    {{ item.HRIS_unique_role }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete   
                                            v-model="userIntrestData.schoolCities"
                                            :items="uniqueClusters"
                                            item-text="description"
                                            item-value="names"
                                            return-object
                                            multiple
                                            clearable
                                            deletable-chips
                                            outlined
                                            chips
                                            class="rounded-xl text-input-field school-text-field"
            
                                            required
                                            @change="clusterNamesChange">
                                            <template #label>
                                                  <span>
                                                    School City <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete v-model="userIntrestData.schools" 
                                                clearable 
                                                deletable-chips
                                                small-chips
                                                outlined class="rounded-xl text-input-field school-text-field"
                                                :items="schools"  
                                                item-text="name" 
                                                :rules="[(v) => !!v || 'School is required']" 
                                                required id="schoolBox"
                                                @change="locationChange()"
                                                >
                                                <template #label>
                                                  <span>
                                                    Preferred Location <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete multiple v-model="userIntrestData.otherlocation" clearable
                                                deletable-chips outlined
                
                                                class="rounded-xl text-input-field school-text-field jobseeker-interest-chip"
                                                small-chips :items="otherSchools" item-text="name" item-value="name"
                                                :rules="[(v) => !!v || 'School is required']" required id="schoolBox"
                                                label="Other Locations">
                                                <template v-slot:item="{ item, attrs, on }">
                                                    <v-list-item v-bind="attrs" v-on="on"
                                                        :disabled="item.name == userIntrestData.schools">
                                                        <template v-slot:default="{ active }">
                                                            <v-list-item-action>
                                                                <v-checkbox :input-value="active" color="primary"
                                                                    :disabled="item == userIntrestData.schools"></v-checkbox>
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    {{ item.name }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete   
                                            v-model="userIntrestData.subjects"
                                            :items="subjects"
                                            item-text="name"
                                            item-value="name"
                                            small-chips
                                            multiple
                                            clearable
                                            deletable-chips
                                            outlined
                                            chips
                                            class="rounded-xl text-input-field "
                                            @change="enforceSubjectLimit"
                                            :error="!!subjectLimitError"
                                            @blur="clearSubjectError"
                                            :error-messages="subjectLimitError"
                                            required
                                            :disabled="(campaignStatus && campaignStatus.length > 1)"
                                            
                                            
                                            >
                                            <template #label>
                                                  <span>
                                                    Subjects <span style="color: red">*</span>
                                                  </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-container>
                                        <v-divider></v-divider>
                                        <div class="d-flex justify-end ma-4">
                                          <v-btn 
                                          @click="goToUsers"
                                          class="btn outline-btn elevation-0 mr-4"
                                          rounded
                                          depressed>Cancel</v-btn>
                                          <v-btn
                                          depressed
                                          :class="isFormValid ? 'btn outline-btn elevation-0' : ''"
                                          @click="updateUser"
                                          rounded
                                          :disabled="!isFormValid"
                                          >Update</v-btn>
                                        </div>
                                        
                                    </v-card>
                                    
                                </div>
                              
          </v-card-text>
          
          
        </v-card>
        
    </div>


      <!-- Success Dialog -->
      <v-dialog v-model="successDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="d-flex flex-column align-center">
              <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 py-4">
                User Updated
              </p>
              <v-btn class="btn primary-btn" large width="157px" rounded
                @click="successDialog = false; $router.push('/users')">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>



      <v-dialog v-model="stopEdit" class="cdz" max-width="500px" persistent>
        <v-card>
          <v-container fluid class="pa-4">
            <v-card-text class="d-flex flex-column align-center">
              <p class="text-h6">
                Candidate has already taken the test. 
                <br><div class="text-center text-h6">Details can no longer be edited.</div>
              </p>
              <v-btn class="btn primary-btn mt-4" large width="157px" rounded
                @click="stopEdit = false;">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>


    </div>

  </div>
</template>
<script>
import "../styles.css";
import { validationMixin } from "vuelidate";
import AuthService from "../services/AuthService";

import { required, email } from "vuelidate/lib/validators";
import AddressController from "@/controllers/AddressController";
import UsersController from "@/controllers/UsersController";
import LevelController from "@/controllers/LevelController";
import SubjectController from "@/controllers/SubjectController";
import GradeController from "@/controllers/GradeController";
import BoardController from "@/controllers/BoardController";
import SchoolController from "@/controllers/SchoolController";
import algoliasearch from "algoliasearch";
import { collection, getDocs, getDoc, query, where } from "firebase/firestore";
import { onSnapshot, doc } from "firebase/firestore";

import { db } from "../firebase";
import CampTotalPieChart from "./CampTotalPieChart.vue";
import CampTotalPieChartLevel from "./CampTotalPieChartLevel.vue";
import { liveListenerUnsubscriber } from "@/mixins/liveListenerUnsubcriber";
import UserNavMenu from "@/components/UserNavMenu.vue";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import CampaignController from "@/controllers/CampaignController";

export default {
  mixins: [ validationMixin, liveListenerUnsubscriber ],

  validations: {
    email: { required, email },
  },
  components: {
    CampTotalPieChart,
    CampTotalPieChartLevel,
    UserNavMenu

  },
  name: "UpdateJobSeekerView",
  data() {
    return {
      dobRules: [
        (v) => !!v || "Date of Birth is required",
        // (v) =>
        //   /^\d{4}-\d{2}-\d{2}$/.test(v) ||
        //   "Date of Birth must be in YYYY-MM-DD format",
      ],
      rules: {
        required: (value) => !!value || "Field is required",
      },
      algoliaIndex: null,
      options: {},
      isLoading: true,
      pageSize: 10,
      page: 1,
      count: 0,
      e1: 1,
      roleCluster: "",
      roleSchool: "",
      clustersSchool: [],
      selectedStatusFilter: [],
      screeningTestFilter: [],
      mainsTestFilter: [],
      roleTypeFilter: [],
      levelTypeFilter: [],
      subjectTypeFilter: [],
      clusterTypeFilter: [],
      schoolTypeFilter: [],
      showClusterSchool: [],
      searchSchool: "",
      status: ["active", "Inactive", "Invited"],
      ScreeningTestStatus: ["Passed", "Failed", "Yet to Start"],
      role: ["Teacher", "Job Seekers"],
      dLoading: 0,
      editId: null,
      formbtnBool: false,
      experience: "Experienced",
      levels: [],
      levelId: -1,
      boards: [],
      hover: "",
      graphSchools: [],
      horizontalBarData: [],
      completionStatusGraph: [],
      levelChartData: [],

      schools: [],
      snapCluter: [],
      clustersSnap: [],

      subjects: [],
      clusterSchool: "",
      subjectId: [],
      isCurrentlyWorking: false,
      errorMessage: "Failed",

      dialog: false,
      deleteDialog: false,
      singleSelect: false,
      selected: [],
      experienceYear: -1,
      deleteUserDetails: false,
      experienceMonth: -1,
      filterDialog: false,
      rolePosition: "",
      board: "",
      gradesData: [],
      gradeId: -1,
      startDate: -1,
      endDate: -1,
      extraCarricularActivities: "",
      isCreatingUser: false,
      successDialog: false,
      resendInviteSuccessDialog: false,
      deleteSuccessDialog: false,
      errorDialog: false,
      boardsData: [],
      tableLevels: [],
      subjectsData: [],
      school: '',
      schoolData: [],
      store: "",
      search: "",
      searchVal: "Job Seeker",
      vgosCount: 0,
      jobSeekerCount: 0,
      allCount: "",
      headers: [
        { text: "Full Name", value: "fullname", cellClass: "w-10" },
        {
          text: "Email ID",
          value: "personalInfo.contactInfo.email",
          cellClass: "w-15",
        },
        {
          text: "Phone No",
          value: "personalInfo.contactInfo.phoneNumber",
          cellClass: "w-15",
        },
        { text: "Created On", value: "createdOn", cellClass: "w-15" },
        { text: "Status", value: "status", cellClass: "w-15" },
        //{ text: "Role", value: "userType", cellClass: "w-15" },
        { text: "Last active on", value: "updatedOn", cellClass: "w-15" },
        { text: "Actions", value: "actions", cellClass: "w-10" },
      ],
      personalInfo: {
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        gender: "",
        isEmailVerified: false,
        isPhoneVerified: false,
        contactInfo: {
          email: "",
          phoneNumber: "",
        },
        addressInfo: {
          countryName: "India",
          stateName: "",
          districtName: "",
          tulakName: "",
          cityName: "",
          pincode: null,
          address: "",
        },
      },
      academicsInfo: [
        {
          institution: "",
          programme: "",
          startDate: "",
          endDate: "",
          fieldOfStudy: "",
          gradeScore: 0,
          gradeType: "",
          certificateUrl: "",
        },
      ],
      professionalInfo: [
        {
          experienceYear: 0,
          experienceMonth: 0,
          position: "",

          board: 0,
          startDate: Date.now(),
          endDate: Date.now(),
          levels: [],
          grades: [],
          subjects: [],
          school: "",
          otherName: "",
        },
      ],
      expandedPanelIndex: 0, // set the last panel as expanded by default
      countries: [
        {
          name: "India",
        },
      ],
      states: [],
      districts: [],
      cities: [],
      talukas: [],
      users: [],
      employeeType: [
        {
          id: 1,
          name: "Permanent",
        },
        {
          id: 2,
          name: "Contract",
        },
        {
          id: 3,
          name: "Prohibition",
        },
      ],
      algoliaData: [],
      preloader: true,
      teachingInterests: {},
      userIntrestData:{},
      otherJobRoles:[],
      jobRoles:[],
      departments:[],
      jobTypes:[],
      otherSchools:[],
      uniqueClusters: [],
      schools:[],
      previousJobType: null,    
      userId:null,
      campaignId:null,
      oldSubjects:[],
      subjectLimitError: '',
      stopEdit:false,
      userInfo:null,
      campaignStatus:[],
      interviewStatus:false,
    };
  },


  watch: {
    clusterTypeFilter(newValue) {
      console.log("cluster New Value", newValue)
      this.getClustersSchool(newValue);
    },
    options: {
      handler() {
        console.log(this.options);
        this.pageSize = this.options.itemsPerPage;
        this.page = this.options.page;
        this.fetchUsers();
      },
      deep: true,
    },
    searchSchool(newValue) {

      if (newValue === '') {
        this.showClusterSchool = this.clustersSchool;
      } else {
        const lowercaseNewValue = newValue.toLowerCase();
        this.showClusterSchool = this.clustersSchool.filter((obj) =>
          obj.name.toLowerCase().includes(lowercaseNewValue)
        );
      }

    },


    search(newValue) {
      var searchValue = "Job Seeker";
      this.searchVal = "";
      console.log(newValue);
      if (this.search == "Un-assessed") {
        this.search = 'inprogress';
      }
      this.pageSize = this.options.itemsPerPage;
      this.page = this.options.page;
      this.options.page = 1;
      this.searchVal = searchValue + " " + newValue;

      this.fetchUsers();
    },
    
  },

  methods: {
    // async getSchool(cluster) {
    //         const response = await SchoolController.getSchool({cluster});
    //         if (response.status == 200) {
    //             if(!cluster){
    //                 this.otherSchools = response.data.schools;
    //             }
    //             this.schools = response.data.schools;
    //         } else {
    //             alert(response.data.error);
    //         }
    // },
    enforceSubjectLimit(value) {
      if (value.length > 3) {
        this.subjectLimitError = 'You can select up to 3 subjects only';
        this.userIntrestData.subjects = value.slice(0, 3);
      } else {
        this.subjectLimitError = '';
      }
    },
    clearSubjectError() {
      this.subjectLimitError = '';
    },
    async getSchool(cluster) {
      console.log('cluster',cluster)
            const clusters = typeof cluster === 'string' ? cluster?.split(',').filter(_cluster => _cluster) : []
            const response = await SchoolController.getSchool();
            if (response.status == 200) {
                this.otherSchools = response.data.schools;
                this.schools = clusters?.length > 0 ? this.otherSchools.filter(({cluster}) => clusters.includes(cluster)) : this.otherSchools;
            } else {
                alert(response.data.error);
            }
    },
    async clusterNamesChange(event) {
            this.userIntrestData.clusterNames = event?.map(({names}) => names)?.flat(1)?.join(',')
            this.userIntrestData.schools = [];
            // this.userIntrestData.subjects = [];
            this.userIntrestData.otherlocation = []
            await this.getSchool(this.userIntrestData.clusterNames)
        },
    async jobTypeChange() {
            
            if(this.previousJobType !== null && this.previousJobType !== undefined && this.previousJobType !== this.userIntrestData.jobType){
              this.userIntrestData.jobRole = null;
              this.userIntrestData.department = null;
              this.userIntrestData.otherJob = [];
              this.userIntrestData.schools = [];
              this.userIntrestData.schoolCities = [];
              this.userIntrestData.subjects = [];
              this.userIntrestData.otherlocation =[];
            }
            this.previousJobType = this.userIntrestData.jobType;
            const response = await AudienceRolesController.getJobTypeByName(this.userIntrestData.jobType)
            if(response.status == 200){
              const jobTypeId = response.data.data.id;
              this.getAudienceRoles(true)
              this.getAudienceRoleDepartments(jobTypeId)
            
            } 
            
    },
    async departmentChange(){
              await this.getAudienceRoles()
              this.userIntrestData.jobRole = null;
              this.userIntrestData.otherJob = [];
              this.userIntrestData.schools = [];
              this.userIntrestData.schoolCities = [];
              this.userIntrestData.subjects = [];
              this.userIntrestData.otherlocation =[];
    },
    async getAudienceRoles(updateOtherJobRoles = false) {
      const response = await AudienceRolesController.getJobTypeByName(this.userIntrestData.jobType);
      let jobTypeId = null;
      if (response.status === 200) {
        jobTypeId = response.data.data.id;
      }
      if (this.userIntrestData.jobType && jobTypeId) {
        if (updateOtherJobRoles) {
          const response = await AudienceRolesController.getAudienceRolesByDepartment(jobTypeId);
          this.otherJobRoles = this.sortByLevel(response.data.audienceRoles);
        } 
          const response = await AudienceRolesController.getAudienceRolesByDepartment(jobTypeId, this.userIntrestData.department);
          this.jobRoles = this.sortByLevel(response.data.audienceRoles);
      }
    },
    async getAudienceRoleDepartments(departmentGroupId) {
            const response = await AudienceRolesController.getAudienceRoleDepartmentsByDepartmentGroupId(departmentGroupId);            
            if(response.status==200){
                this.departments = response.data.departments;
            }
    },
    sortByLevel(roles){
            const levelsOrder = ["Foundational", "Preparatory", "Middle", "Secondary", "Senior Secondary", "Support", "Lead", "HOD"];
            return roles?.sort((a, b) => levelsOrder.indexOf(a.level) - levelsOrder.indexOf(b.level));
    },
    jobroleChange({ level, HRIS_unique_role, id ,groupedSkillsId , hiringManagerJobRole}) {
            this.userIntrestData.jobRole = { HRIS_unique_role, id, level, groupedSkillsId, hiringManagerJobRole }
            this.groupedSkillsId = this.userIntrestData.jobRole.groupedSkillsId;
            console.log('this.groupedSkillsId',this.userIntrestData.jobRole)
            this.userIntrestData.otherJob = [];
            this.userIntrestData.schools = [];
            this.userIntrestData.schoolCities = [];
            this.userIntrestData.subjects = [];
            this.userIntrestData.otherlocation =[];
            this.getSelectedSubjects();          
    },
    locationChange(){
         this.userIntrestData.otherlocation =[];
         this.userIntrestData.schoolCode = this.schools.find(school => this.userIntrestData.schools == school.shortName).schoolCode;
    },
    async getSelectedSubjects() {
      console.log('subjects get',this.userIntrestData.jobRole)
      console.log('this.userIntrestData in getSelectedSubjects',this.userIntrestData)
          if(this.userIntrestData.jobRole.groupedSkillsId){
                const response = await SubjectController.fetchSubjectsByGrades(this.userIntrestData.jobRole.groupedSkillsId, this.userIntrestData.jobRole.level);
                this.subjects = response.data.subjects;
            }
            
    },
    async getClusterCities() {
        const response = await SchoolController.getClusterCities();            
        if(response.status==200){
            this.uniqueClusters = response.data.uniqueClusters;
        }
    },
//     initializeJobType() {
//       console.log('typeof this.userIntrestData.jobType',typeof this.userIntrestData.jobType)
//   if (typeof this.userIntrestData.jobType === 'string' && this.jobTypes.length) {
//     const match = this.jobTypes.find(
//       (j) => j.name.trim().toLowerCase() === this.userIntrestData.jobType.trim().toLowerCase()
//     );
//     if (match) {
//       this.userIntrestData.jobType = match;
//       this.jobTypeChange();
//     } else {
//       console.warn('Job type match not found for:', this.userIntrestData.jobType);
//     }
//   }
// },
    async filterUser(
      selectedStatusFilter,
      screeningTestFilter,
      mainsTestFilter,
      roleTypeFilter,
      levelTypeFilter,
      subjectTypeFilter,

    ) {
      this.dLoading = true;
      var statusId = "";
      var screeningId = "";
      var mainsId = "";
      var roleId = "";
      var levelId = "";
      var subjectId = "";
      var schoolId = "";
      selectedStatusFilter.forEach((item) => {
        statusId = statusId + item + " ";
      });
      screeningTestFilter.forEach((item) => {
        screeningId = screeningId + item + " ";
      });
      mainsTestFilter.forEach((item) => {
        mainsId = mainsId + item + " ";
      });
      roleTypeFilter.forEach((item) => {
        roleId = roleId + item + " ";
      });
      levelTypeFilter.forEach((item) => {
        levelId = levelId + item + " ";
      });
      subjectTypeFilter.forEach((item) => {
        subjectId = subjectId + item + " ";
      });
      this.schoolTypeFilter.forEach((item) => {
        schoolId = schoolId + item + " ";
      });


      this.filterVal =
        statusId +
        screeningId +
        mainsId +
        roleId +
        levelId +
        subjectId +
        schoolId + "Job Seekers"
      console.log("filter value = ", this.filterVal)

      await this.algoliaIndex
        .search(this.filterVal, {
          hitsPerPage: this.pageSize,
          page: this.page - 1,
        })
        .then(({ hits }) => {
          console.log(hits);
          this.users = hits;
          this.dLoading = false;

        });
      const { nbHits } = await this.algoliaIndex.search(this.filterVal, {
        hitsPerPage: 0,
      });
      this.dLoading = false;

      this.count = nbHits;
      console.log("filter responce", this.filterVal);
      this.filterDialog = false;
      this.filterData = true;
    },
    async getClustersSchool(clusterTypeFilter) {
      if (this.clusterTypeFilter.length > 0) {
        const response = await SchoolController.getClusterSchool(
          this.clusterTypeFilter
        );
        // console.log("school", response);
        if (response.status == 200) {
          var schools = response.data.schools;
          this.clustersSchool = schools;
          this.showClusterSchool = schools;
          //   console.log("school", this.schools);
        } else {
          alert(response.data.error);
        }
      } else {
        this.schools = [];
      }
    },

    clearFilter() {
      this.selectedStatusFilter = []
      this.screeningTestFilter = []
      this.mainsTestFilter = []
      this.roleTypeFilter = []
      this.levelTypeFilter = []
      this.subjectTypeFilter = []
      this.schoolTypeFilter = [],
        this.filterVal = "Job Seeker",
        this.filterDialog = false;
      this.filterData = false;
      this.filterUser(
        this.selectedStatusFilter,
        this.screeningTestFilter,
        this.mainsTestFilter,
        this.roleTypeFilter,
        this.levelTypeFilter,
        this.subjectTypeFilter,
      );
    },


    handleValue(value) {
      this.search = value; // Update the childValue data property with the emitted value
    },
    handleData(data) {
      this.search = this.levelChartData[data][0];
    },
    getClusterAndSchool() {
      this.roleCluster = this.$store.state.role.clusterName;
      this.roleSchool = this.$store.state.role.schools;
      if (this.roleSchool == undefined) {
        AuthService.logout();
        this.$router.push("/login");
      }

      if (this.roleCluster != "All Clusters") {
        this.cluster = this.roleCluster;
        this.getClusterSchool();
      }
      if (this.roleSchool != "All") {
        this.school = this.roleSchool;
      }
    },
    levelChart() {
      this.$store.state.levelChart = null;
      var levelGraph = [["", ""]];
      var secondary_c = 0;
      var primary_c = 0;
      var middle_c = 0;
      var pre_primary_c = 0;
      var senior_secondary_c = 0;
      this.graphSchools.forEach((scl) => {
        primary_c += scl.primary_jobseeker;
        secondary_c += scl.secondary_jobseeker;
        middle_c += scl.middle_jobseeker;
        pre_primary_c += scl.pre_primary_jobseeker;
        primary_c += scl.primary_jobseeker;
        senior_secondary_c +=
          scl.senior_secondary_jobseeker;
      });

      levelGraph.push(["Primary", primary_c]);
      levelGraph.push(["Pre Primary", pre_primary_c]);
      levelGraph.push(["Secondary", secondary_c]);
      levelGraph.push(["Middle", middle_c]);
      levelGraph.push(["Senior Secondry", senior_secondary_c]);
      this.levelChartData = [["Primary", primary_c], ["Pre Primary", pre_primary_c], ["secondary", secondary_c], ["Middle", middle_c], ["Senior Secondry", senior_secondary_c]]

    },
    CompletionStatusData() {
      var completionStatusGraph = [["", ""]];
      var a_jobseeker_count = 0;
      var unaccessed_jobseeker_count = 0;
      this.graphSchools.forEach((scl) => {
        a_jobseeker_count += scl.accessed_jobseeker;
        unaccessed_jobseeker_count += scl.unaccessed_jobseeker;
      });
      if ((a_jobseeker_count && unaccessed_jobseeker_count) == 0) {
        this.$store.state.assesedChart = null
      }
      else {
        this.$store.state.assesedChart = [["Assessed", a_jobseeker_count], ["Un-assessed", unaccessed_jobseeker_count]]
      }
      completionStatusGraph.push(["Assessed", a_jobseeker_count]);
      completionStatusGraph.push(["Un-assessed", unaccessed_jobseeker_count]);
      this.completionStatusGraph = completionStatusGraph;
    },

    dataOnCluster() {
      var horizontalBarData = [["not found", "500", { role: "style" }]];
      var completionStatusGraph = ["", ""];
      var cartClusterData = [];
      var clutersMap = {};
      var a_jobseeker_c = 0;
      var u_jobseeker_c = 0;
      var a_teacher_c = 0;
      var u_teacher_c = 0;
      this.clustersSnap.forEach((clstr) => {
        a_jobseeker_c = 0;
        u_jobseeker_c = 0;
        a_teacher_c = 0;
        u_teacher_c = 0;
        this.graphSchools.forEach((scl) => {

          if (clstr == scl.cluster) {
            a_jobseeker_c += scl.accessed_jobseeker;
            u_jobseeker_c += scl.unaccessed_jobseeker;
            a_teacher_c += scl.accessed_teacher;
            u_teacher_c += scl.unaccessed_teacher;
          }
        });

        horizontalBarData.push([
          clstr,
          a_jobseeker_c + u_jobseeker_c + a_teacher_c + u_teacher_c,
          "color: #6A4F79",
        ]);
      });

      this.horizontalBarData = horizontalBarData;
    },
    async SnapshotOnCluster() {
      var isSchool = false;

      var graphData = {
        unaccessed_teacher: 0,
        inprogress_teacher: 0,
        accessed_teacher: 0,
        unaccessed_jobseeker: 0,
        inprogress_jobseeker: 0,
        accessed_jobseeker: 0,
        primary_teacher: 0,
        pre_primary_teacher: 0,
        middle_teacher: 0,
        secondary_teacher: 0,
        senior_secondary_teacher: 0,
        primary_jobseeker: 0,
        pre_primary_jobseeker: 0,
        middle_jobseeker: 0,
        secondary_jobseeker: 0,
        senior_secondary_jobseeker: 0,
      };


      const querySnapshot = await getDocs(collection(db, "clusters"));
      if (querySnapshot.empty) {
        alert("Cluster Not Found!!");
        return;
      } else {
        querySnapshot.forEach((doc) => {
          this.clustersSnap.push(doc.data().name);
        });

      }

      if (this.roleCluster != "All Clusters" && this.roleSchool == "All") {
        this.clustersSnap = [];
        this.clustersSnap = [this.roleCluster];
      } else if (
        this.roleCluster != "All Clusters" &&
        this.roleSchool != "All"
      ) {
        this.clustersSnap = [];
        this.clustersSnap = [this.roleCluster];
        isSchool = true;
      } else {
        console.log("empty");
      }
      const clustersRef = new Array(this.clustersSnap.length);


      for (var i = 0; i < this.clustersSnap.length; i++) {
        if (isSchool) {
          clustersRef[i] = doc(
            collection(db, "dashboards", "ums-dashboard", this.clustersSnap[i]),
            this.roleSchool
          );
          let unsubscribe = onSnapshot(
            doc(
              db,
              "dashboards",
              "ums-dashboard",
              this.clustersSnap[i],
              this.roleSchool
            ),
            { includeMetadataChanges: true },
            (doc) => {
              this.graphSchools[0] = doc.data();
              this.dataOnCluster();
              this.CompletionStatusData();
              this.levelChart();
            }
          );
          this.liveListenersToUnsubscribeMixin.push(unsubscribe);
        } else {
          clustersRef[i] = collection(
            db,
            "dashboards",
            "ums-dashboard",
            this.clustersSnap[i]
          );

          let unsubscribe = onSnapshot(clustersRef[i], (querySnapshot) => {
            // schools = [];

            querySnapshot.docChanges().forEach((change) => {
              if (change.type === "added") {

                this.graphSchools.push(change.doc.data());
              }
              if (change.type === "modified") {
                let data = change.doc.data();

                const index = this.graphSchools.findIndex(
                  (school) => school.id === data.id
                );
                this.graphSchools[index] = data;
              }
              if (change.type === "removed") {
                let remove = change.doc.data();
                const removeindex = this.graphSchools.findIndex(
                  (school) => school.id === remove.id
                );
                this.graphSchools.splice(removeindex, 1);
              }
            });

            this.dataOnCluster();
            this.CompletionStatusData();
            this.levelChart();
          });
          this.liveListenersToUnsubscribeMixin.push(unsubscribe);
        }
      }
    },


    getClusterOrSchool() {
      var CData = this.$store.state.role.clusterName
      var SData = this.$store.state.role.schools

      this.clusterSchool = "";
      if ((CData == 'All Clusters')) {
        this.clusterSchool = ""
      }
      else if ((CData != 'All Clusters') && (SData == 'All')) {
        this.clusterSchool = CData
      }
      else {
        this.clusterSchool = SData;
      }
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    async getTotalCount() {
      if (this.clusterSchool != "") {
        const { nbHits } = await this.algoliaIndex.search(this.searchVal, {
          hitsPerPage: 0,
        });
        const allHits = await this.algoliaIndex.search(this.clusterSchool, { hitsPerPage: 0 });
        const vgosHits = await this.algoliaIndex.search("Teacher " + this.clusterSchool);
        const jobSeekerCount = await this.algoliaIndex.search("Job Seeker " + this.clusterSchool);

        this.count = jobSeekerCount.nbHits;
        this.allCount = allHits.nbHits;
        this.vgosCount = vgosHits.nbHits;

      } else {
        const { nbHits } = await this.algoliaIndex.search(this.searchVal + " " + this.clusterSchool, {
          hitsPerPage: 0,
        });
        const allHits = await this.algoliaIndex.search(this.clusterSchool);
        const vgosHits = await this.algoliaIndex.search(this.clusterSchool + " " + "Teacher");
        const jobSeekerCount = await this.algoliaIndex.search("Job Seeker " + this.clusterSchool);

        this.count = jobSeekerCount.nbHits;
        this.allCount = allHits.nbHits;
        this.vgosCount = vgosHits.nbHits;
      }

    },
    getDate(timeStamp) {
      return this.formatDate(timeStamp);
    },
    async updateProfessionalInfo(data, userId) {
      const response = await UsersController.updateProfessionalInfo(
        data,
        userId,
        data.id
      );
      // console.log(response);
    },
    goToStep2() {
      if (this.formbtnBool) {
        if (this.$refs.step1.validate()) {
          // this.updateUser(this.personalInfo, this.editId);
          this.e1 = 2;
        }
      } else {
        if (this.$refs.step1.validate()) {
          this.e1 = 2;
          this.expandedPanelIndex = 0;
          // console.log(this.personalInfo)
        }
      }
    },
    updateData() {

      var item = this.$store.state.user
      this.campaignStatus = item.campaignStatus;
      this.userIntrestData = item.teachingInterests;
      console.log(this.userIntrestData,'this.userIntrestData')
      this.getSelectedSubjects();
      this.oldSubjects = this.userIntrestData.subjects;
      this.subjects = this.userIntrestData.subjects;
      this.uniqueClusters = this.userIntrestData.schoolCities
      if (item == undefined) {
        this.$router.push('/users')
        return
      }
      this.editId = item.userId;
      this.userId = item.userId;
      this.campaignId = item.campaignId;
      this.getUsersCurrentInterviewStatus(this.userId,this.campaignId)
      
      console.log("edit id assigned", this.editId)
      console.log("edit id assigned", item.personalInfo)


      this.personalInfo = item.personalInfo != undefined ? item.personalInfo : this.personalInfo;
      console.log('item',item)
      this.academicsInfo = item.academicsInfo != undefined ? item.academicsInfo : this.academicsInfo;
      this.professionalInfo = item.professionalInfo != undefined ? item.professionalInfo : this.professionalInfo;


      if (item.teachingInterests) {
        this.teachingInterests = item.teachingInterests;
      }

      this.dialog = true;


    },

    // async getSubjects() {
    //   const response = await SubjectController.getSubject();
    
    //   // console.log("suvject res", response);

    //   if (response.status == 200) {
    //     this.subjects = response.data.subjects;
    //     console.log('subjects',this.subjectsData)
      
    //   } else {
    //     alert("subject Not Found!!");
    //   }
    // },
    async getLevels() {
      const response = await LevelController.getLevel();
      if (response.status == 200) {
        this.tableLevels = response.data.levels;
      } else {
        alert("Levels Not Found!!");
      }

      // console.log("level data", this.levelData.rows);
    },
    async getGrades() {
      const response = await GradeController.getAllGrades();
      //console.log(response);

      // console.log("grade data", response);
      if (response.status == 200) {
        this.gradesData = response.data.grades;
      } else {
        alert("Levels Not Found!!");
      }
    },
    goToStep3() {
      if (this.formbtnBool) {
        // this.updateAcademics();
        this.e1 = 3;
      } else {
        if (this.$refs.step2.validate()) {
          this.e1 = 3;
          this.expandedPanelIndex = 0;
        }
      }
    },
    async getUserHistory(userId){
        if(userId){
          const response = await UsersController.getUserHistory(userId)
          if(response.flag){
          this.userHistory = response.data;
          }
        }
    },
    async getUsersCurrentInterviewStatus(userId,campaignId){
      const response = await UsersController.getUsersCurrentInterviewStatus(userId,campaignId)
          if(response.flag){
          this.interviewStatus = response.data.hasInterviewDetails;
          console.log('this.userLatestStatus',this.interviewStatus)  
      }
    },
    async updateUser() {
      const res = await UsersController.getUserInfo(this.editId)
      
        if(res.flag){
          this.userInfo = res.user
          await UsersController.getUsersCurrentInterviewStatus(this.editId,this.campaignId)
          if(this.interviewStatus){
            this.stopEdit = true;
          }
          else{
            
            this.teachingInterests.levels = [this.teachingInterests.jobRole.level];
            let data =  {
            personalInfo: this.personalInfo,
            // professionalInfo: this.professionalInfo,
            teachingInterests: this.teachingInterests,
            };
            console.log('data',data)
            console.log('editId',this.editId)
            const response = await UsersController.updateUserInfo(
            data,
            this.editId
            );
            if (response.status) {
            this.isCreatingUser = false;
            this.successDialog = true;
            this.dialog = false;
            if (JSON.stringify(this.oldSubjects) !== JSON.stringify(this.userIntrestData.subjects)) {
              CampaignController.fetchQuestionNonAdaptiveTest(this.userId, this.campaignId);
              CampaignController.generateDemoTopics(this.userId, this.campaignId, this.userIntrestData.subjects, this.teachingInterests.jobRole.level, this.userInfo.userType, false, [], false);
            }
        
            } else {
              this.isCreatingUser = false;
              this.errorMessage = response.data.error;
              this.errorDialog = true;
            }
          }
        }
     
      // for update personal info
      
      
    },
    async updateAcademics(qualification, usrid) {
      const response = await UsersController.updateAcademics(
        qualification,
        usrid,
        qualification.id
      );
      console.log(response);
    },
    async getAcademics(id) {
      const response = await UsersController.getAcademics(id);
      //console.log("res", response)
      this.academicsInfo = response.data.data;
      // console.log("academic data comming", this.academicsInfo)
    },

    async getProfessionalInfo(id) {
      const response = await UsersController.getprofessionalInfo(id);
      this.professionalInfo = response.data.data;
      // console.log("professional data comming", this.professionalInfo)
    },
    formbtn() {
      return this.formbtnBool === false ? "Create" : "Update";
    },



    addAcademicQualification() {
      this.academicsInfo.push({
        institution: "",
        programme: "",
        startDate: "",
        endDate: "",
        fieldOfStudy: "",
        gradeScore: 0,
        gradeType: "",
        certificateUrl: "",
      });
      this.expandedPanelIndex = this.academicsInfo.length - 1;
    },
    addProfessionalInfo() {
      this.professionalInfo.push({
        experienceYear: 0,
        experienceMonth: 0,
        position: "",
        board: 0,
        startDate: "",
        endDate: "",
        school: "",
      });
      this.expandedPanelIndex = this.professionalInfo.length - 1;
    },

    async fetchCountries() {
      const response = await AddressController.getCountries();

      if (response.data.success) {
        this.countries = response.data.data.rows;
      } else {
        alert(response.data.error);
      }
      //console.log(this.countries);
    },

    async fetchStates() {
      var states = [];
      const querySnapshot = await getDocs(collection(db, "states"));
      if (querySnapshot.empty) {
        alert("States Not Found!!");
        return;
      } else {
        querySnapshot.forEach((doc) => {
          states.push(doc.data());
        });
      }
      this.states = states;
    },
    async fetchDistricts() {
      //console.log(this.personalInfo.state_id);
      const q = query(collection(db, "districts"), where("state", "==", this.personalInfo.addressInfo.stateName));
      const querySnapshots = await getDocs(q);
      this.districts = [];
      querySnapshots.forEach((doc) => {
        this.districts.push(doc.data());
        // console.log(doc.data());

      });

    },


    async fetchCitiesAndTalukas() {


      const q = query(collection(db, "cities"), where("state", "==", this.personalInfo.addressInfo.stateName), where("district", "==", this.personalInfo.addressInfo.districtName));
      const querySnapshots = await getDocs(q);
      this.cities = [];
      querySnapshots.forEach((doc) => {
        this.cities.push(doc.data());
        // console.log(doc.data());

      });

    },
    removeDataFromSteps() {
      this.deleteUserDetails = true;
      if (this.e1 == 2) {
        this.academicsInfo.splice(this.indexValue, 1);
      } else if (this.e1 == 3) {
        this.professionalInfo.splice(this.indexValue, 1);
      }
      this.deleteUserDetails = false;
      this.indexValue = null;
    },
    openDeleteDiolog(index) {
      this.indexValue = index;
      this.deleteUserDetails = true;
    },
    async getBoards() {
      const response = await BoardController.getBoards();
      // console.log(response);

      if (response.status == 200) {
        this.boardsData = response.data.boards;
      } else {
        alert("Boards Not Found!!");
      }
    },
  
    async getAudienceRoleGroups() {
      console.log('zncmbnbmb')
        const response = await AudienceRolesController.getAudienceRoleGroups();
        this.jobTypes = response.data.audienceRoleGroup
        console.log('this.jobTypes',this.jobTypes)
        if(response.status==200){
          this.jobTypes = response.data.audienceRoleGroup;
        }
    },
    goToUsers() {
      this.$router.push('/users');
    }


  },
  computed: {
    isFormValid() {
    // Explicitly access nested properties to establish reactivity
    const jobType = this.userIntrestData.jobType;
    const department = this.userIntrestData.department;
    const jobRole = this.userIntrestData.jobRole;
    const schoolCities = this.userIntrestData.schoolCities;
    const schools = this.userIntrestData.schools;
    const subjects = this.userIntrestData.subjects;
    
    return (
      !!jobType &&
      !!department &&
      !!jobRole &&
      !!schoolCities && schoolCities.length > 0 &&
      !!schools &&
      !!subjects && subjects.length > 0
    );
  },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    filteredLevel() {
      if (this.searchLevels) {
        const regex = new RegExp(this.searchLevels);
        return this.tableLevels.filter((tableLevels) =>
          regex.test(tableLevels.name)
        );
      } else {
        return this.tableLevels;
      }
    },

    filteredBoard() {
      if (this.searchBoards) {
        const regex = new RegExp(this.searchBoards);
        return this.boardsData.filter((boardData) =>
          regex.test(boardData.name)
        );
      } else {
        return this.tableLevels;
      }
    },
    filteredSubject() {
      if (this.searchSubject) {
        const regex = new RegExp(this.searchSubject);
        return this.subject.filter((subject) => regex.test(subject.name));
      } else {
        return this.subject;
      }
    },
  },
  created() {
    // this.fetchCountries();
    this.updateData();
    this.getAudienceRoleGroups();
    this.fetchStates();
    this.getLevels();
    // this.getSubjects();
    this.getGrades();
    this.getBoards();
    this.getSchool();

    this.$store.state.breadcrumb = "Job Seekers";
  },
  mounted() {
    this.jobTypeChange();
    this.getSchool(this.userIntrestData.clusterNames) 
    console.log('userIntrestData.department',this.userIntrestData.department)
    // this.initializeJobType();
    
    if (this.$store.state.role.createdOn == undefined) {
      this.logout();
    }
    
  
    this.getClusterCities();
    this.getClusterOrSchool();
    this.getClusterAndSchool();

  },
};
</script>
<style scoped>
.graph {
  border-radius: 8px !important;
  margin: 8px;
  height: 132px;
  font-size: 0.8rem;
}

.mar-row {
  margin: 2px !important;
}

.blue-border {
  border-color: blue !important;
}

.pad {
  padding-top: 90px;
}

.cardBorderUser {
  border: 1px solid rgba(77, 105, 91, 0.6);
  border-radius: 8px;
  cursor: pointer;
}
.webapp-registration-container {
.v-chip {
    background: var(--gray-02) !important;
    color: var(--blue-01) !important;
    padding: 0 16px !important;
    border: 1px solid var(--blue-01) !important;
  }
.jobseeker-interest-chip {
    .v-chip {
      border: transparent !important;
    }
  }
}
</style>
  